/* Fransk katalog for locale-no.js (del 8 av 10).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('fr', {
  'po.todaysPlanBase': 'Plan actuel — le point de départ',
  'po.editTodaysPlan': 'Modifier le plan actuel',
  'po.netWealthToday': 'Patrimoine net aujourd\'hui',
  'po.monthlySavingShort': 'Épargne mensuelle',
  'po.extraDebtRepayment': 'Remboursement de dette supplémentaire',
  'po.return': 'Rendement',
  'po.retirementAge': 'Âge de départ à la retraite',
  'po.adjustAssumptions': 'Ajuster les hypothèses',
  'po.lifeEvents': 'Événements de vie',
  'po.lifeEventsSub': 'Planifiez les grands événements à venir — enfants, logement, congé, année sabbatique — et voyez comment ils façonnent l\'ensemble',
  'po.addEvent': 'Ajouter un événement',
  'po.lifeEventsHelp': 'Saisissez les événements futurs avec une date de début, un coût ponctuel, un effet mensuel et une durée. Chaque événement actif est placé au bon moment dans la prévision. Désactivez un événement pour voir le plan sans lui. Les événements sont enregistrés pour l\'année sélectionnée.',
  'po.effectOver5Years': 'Effet sur 5 ans',
  'po.goalScore': 'Score d\'objectifs',
  'po.goalScoreSub': 'Dans quelle mesure vous êtes en bonne voie pour atteindre vos objectifs — et ce qui améliore le score',
  'po.whatAffectsGoalScore': 'Ce qui influence le score d\'objectifs',
  'po.myRecommendationNow': 'Ma recommandation en ce moment',
  'po.prioritise': 'Prioriser',
  'po.talkAboutPlan': 'Parlez-moi du plan',
  'po.yourGoals': 'Vos objectifs',
  'po.yourGoalsSub': 'Chaque objectif avec le montant restant, la date prévue et la probabilité',
  'po.newGoal': 'Nouvel objectif',
  'po.addGoal': 'Ajouter un objectif',
  'po.editGoal': 'Modifier l\'objectif',
  'po.deleteGoal': 'Supprimer l\'objectif',
  'po.remaining': 'Restant',
  'po.expectedDone': 'Réalisation prévue',
  'po.probability': 'Probabilité',
  'po.largestEffect': 'Effet le plus important',
  'po.howReachFaster': 'Que puis-je faire pour y arriver plus vite ?',
  'po.nextMilestone': 'Prochaine étape',
  'po.nextMilestoneSub': 'Ce que vous atteindrez probablement en premier — par ordre chronologique',
  'po.yourLifePlan': 'Votre plan de vie',
  'po.yourLifePlanSub': 'Les principales étapes financières à venir, construites à partir de vos objectifs et de votre plan',
  'po.adjustLive': 'Ajustez les hypothèses — la prévision, les objectifs et les dates se mettent à jour en temps réel pendant que vous faites glisser.',
  'po.deleteGoalTitle': 'Supprimer l\'objectif ?',
  'po.deleteGoalConfirm': 'Supprimer l\'objectif',
  'po.doYouWantToDelete': 'Voulez-vous supprimer',
  'po.ownPartnerSharedSub': 'Aperçu de vos coûts, de ceux de votre partenaire et des coûts communs',
  'po.you': 'Vous',
  'po.partner': 'Partenaire',
  'po.householdSpends': 'Le foyer dépense',
  'po.reportSub': 'Consultez, comparez, imprimez et téléchargez les rapports mensuels et annuels',
  'po.print': 'Imprimer',
  'po.downloadPdf': 'Télécharger le PDF',
  'po.pdfBusy': 'Création du PDF …',
  'po.pdfFailed': 'Impossible de créer le PDF du rapport. Réessayez, ou utilisez Imprimer.',
  'po.pdfFileName': 'rapport-finances-personnelles',
  'po.compareWith': 'Comparer avec',
  'po.compareHelp': 'Placez une période antérieure à côté pour voir l\'évolution. « Désactivé » affiche uniquement la période sélectionnée.',
  'po.ongoingPeriod': 'Période en cours — les chiffres sont provisoires',
  'po.plummaSummary': 'Résumé de SuperPlumma',
  'po.wentWell': 'Ce qui s\'est bien passé',
  'po.canImprove': 'Ce qui peut être amélioré',
  'po.focusNextMonth': 'Priorité le mois prochain :',
  'po.goDeeper': 'Vous voulez aller plus loin ? Posez-moi des questions sur le rapport.',
  'po.plummaNoticed': 'SuperPlumma a remarqué',
  'po.savingsRate': 'Taux d\'épargne',
  'po.noImportedCosts': 'Aucun coût importé',
  'po.totalCosts': 'Total des coûts',
  'po.whatHappensNext': 'Et ensuite ?',
  'po.setAsideOver12': 'Mis de côté sur 12 mois',
  'po.averagePerMonth': 'Moyenne par mois',
  'po.askWhatHappensNext': 'Demandez-moi ce qui va se passer ensuite',
  'po.whatFiguresMean': 'Ce que signifient les chiffres',
  'po.youHaveStated': 'Vous avez indiqué que',
  'po.howItLooksAhead': 'Les perspectives',
  'po.inSixMonths': 'Dans 6 mois',
  'po.inTwelveMonths': 'Dans 12 mois',
  'po.assetCategoryPh': 'Ex. Immobilier',
  'po.assetsAndWealth': 'Actifs et patrimoine',
  'po.assetsAndWealthSub': 'Tout ce que vous possédez réuni — logement, véhicules, épargne et investissements',
  'po.assetsHelp': 'La valeur totale de ce que vous possédez, vos dettes et le patrimoine net (actifs moins dettes). « Variation de valeur attendue » résume la façon dont les actifs devraient prendre ou perdre de la valeur au cours de l\'année.',
  'po.totalAssets': 'Total des actifs',
  'po.netWealth': 'Patrimoine net',
  'po.expectedChangePerYear': 'Variation de valeur attendue par an',
  'po.liquid': 'Liquide (épargne et fonds)',
  'po.assetCount': 'Nombre d\'actifs',
  'po.wealthHealth': 'Santé patrimoniale',
  'po.wealthHealthSub': 'Évaluation globale de la solidité de votre patrimoine — diversification, liquidité, risque et taux d\'endettement',
  'po.wealthStrongestOn': 'Votre patrimoine obtient son meilleur score sur',
  'po.wealthDistribution': 'Répartition de votre patrimoine par catégorie',
  'po.expectedDevelopment': 'Évolution attendue',
  'po.expectedDevelopmentSub': 'Basée sur la variation de valeur que vous avez saisie pour chaque actif',
  'po.projectionHelp': 'La projection utilise la variation de valeur annuelle attendue que vous avez saisie pour chaque actif. Plumme ne récupère pas encore de données de marché externes pour l\'immobilier, les voitures d\'occasion ou les fonds.',
  'po.withYourAssumptions': 'Avec les hypothèses que vous avez saisies, votre patrimoine évolue d\'environ',
  'po.explainSimply': 'Expliquer l\'évolution simplement',
  'po.watchingClosely': 'Sous surveillance particulière',
  'po.watchingCloselySub': 'Les actifs qui devraient perdre de la valeur ou progresser moins vite que l\'inflation',
  'po.explain': 'Expliquer',
  'po.yourAssets': 'Vos actifs',
  'po.yourAssetsSub': 'Appuyez sur un actif pour modifier sa valeur et ses détails',
  'po.addAsset': 'Ajouter un actif',
  'po.askAboutTax': 'Posez-moi des questions sur l\'impôt',
  'po.taxAssistant': 'Assistant de skattemelding',
  'po.taxAssistantSub': 'SuperPlumma vous guide pas à pas et adapte les questions au fur et à mesure',
  'po.deductionHunter': 'Chasseur de déductions',
  'po.deductionHunterSub': 'Les déductions sont triées par valeur attendue — commencez en haut, là où le gain est le plus important',
  'po.whyIThinkThis': 'Pourquoi est-ce que je pense cela ?',
  'po.dataIUsed': 'Données utilisées',
  'po.whyYouQualify': 'Pourquoi vous avez droit à la déduction',
  'po.estimatedTaxBenefit': 'Avantage fiscal estimé',
  'po.taxOptimisation': 'Optimisation fiscale',
  'po.taxOptimisationSub': 'Des mesures concrètes triées par échéance — et ce qu\'elles signifient pour cette année et la suivante',
  'po.nextYearOnwards': 'L\'année prochaine et au-delà',
  'po.aiTaxCheck': 'Contrôle fiscal AI',
  'po.aiTaxCheckSub': 'SuperPlumma examine les informations fiscales que vous avez importées',
  'po.readyToFile': 'Prêt pour le contrôle externe',
  'po.readyToFileSub': 'Comparez la base avec la skattemelding et les relevés annuels',
  'po.checkBasis': 'Base de contrôle',
  'po.requiresIntegration': 'Nécessite une intégration officielle, une authentification forte et une approbation explicite',
  'po.filingUnavailable': 'Dépôt non disponible',
  'po.whatIsMissing': 'Que manque-t-il avant le contrôle externe ?',
  'po.whatRemains': 'Ce qu\'il reste à faire',
  'po.taxBasisNotFetched': 'La base fiscale n\'a pas été récupérée',
  'po.alreadyVerified': 'Déjà vérifié',
  'po.nothingVerified': 'Rien n\'a encore été vérifié.',
  'spx.taxScheme': 'Régime fiscal et de taxes',
  'spx.noItems': 'Aucun élément enregistré pour le moment.',
  'spx.removeSpec': 'Supprimer la ventilation',
  'prd.import': 'Importer des produits',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Exporter les produits',
  'prd.csvName': 'Produits CSV',
  'prd.excelName': 'Produits Excel',
  'prd.countTemplateName': 'Modèle de comptage d\'inventaire',
  'prd.countTemplateEmpty': 'Aucune marchandise à compter. Le modèle de comptage inclut les produits de type Marchandise.',
  'prd.countTemplateDone': 'Modèle de comptage téléchargé. Saisissez les quantités au 31.12. et n\'oubliez pas que le stock est évalué au prix d\'achat.',
  'prd.countTemplateError': 'Impossible de créer le modèle de comptage.',
  'prd.colProductId': 'ID produit',
  'prd.colInventoryAccount': 'Compte de stock',
  'prd.colStockToday': 'Stock actuel',
  'prd.colCountedQuantity': 'Quantité comptée',
  'prd.colTotalCostValue': 'Valeur totale au coût',
  'prd.colNote': 'Remarque',
  'prd.countSheetTitle': 'Inventaire',
  'prd.countSheetIntro': 'La quantité et le coût unitaire sont préremplis à partir du registre des produits actuel. Vérifiez-les et corrigez-les d\'après le comptage réel à la date de comptage.',
  'prd.countSheetDate': 'Date de comptage',
  'prd.countSheetCountedBy': 'Compté par',
  'prd.countSheetReference': 'Référence',
  'prd.countSheetSignature': 'Signature',
  'prd.countSheetNoteLabel': 'Remarque',
  'prd.countSheetNote': 'Cette liste documente le comptage. La valeur comptable et la valeur fiscale sont évaluées lors de la clôture annuelle.',
  'prd.countSheetInfoTab': 'Informations',
  'prd.countSheetWrongTemplate': 'Utilisez le modèle de comptage de Plumme. Les colonnes ne correspondent pas.',
  'prd.countSheetOnlyXlsx': 'L\'import automatique prend en charge le modèle Excel (.xlsx). Les autres fichiers sont enregistrés comme documentation.',
  'prd.countSheetTabNotFound': 'Feuille {name} introuvable.',
  'prd.countSheetRowError': 'Ligne {row} : vérifiez l\'article, le compte de stock, la quantité comptée et le coût.',
  'prd.countSheetNoneCounted': 'Aucune quantité renseignée n\'a été trouvée dans la liste de comptage.',
  'prd.countSheetUnmappedAccount': 'Le compte de stock {account} ne peut pas être réparti automatiquement. Vérifiez les comptes lors de la revue.',
  'prd.filterHelp': 'Filtrez les produits par type (marchandise, service, location), selon qu\'ils sont en stock, et selon que les produits supprimés sont affichés.',
  'prd.listTitle': 'Liste des produits',
  'prd.listSub': 'Les marchandises et services que vous vendez',
  'prd.new': 'Nouveau produit',
  'prd.searchPh': 'Rechercher par nom de produit, description, référence ou prix',
  'prd.searchHelp': 'Rechercher par nom de produit, description, référence ou prix.',
  'prd.none': 'Aucun produit pour le moment',
  'prd.listHelpTitle': 'La liste des produits',
  'prd.listHelp': 'Chaque ligne correspond à un produit avec sa référence, son prix, son taux de TVA, son type et son stock. Touchez une ligne pour voir les détails et la modifier.',
  'prd.detailsTitle': 'Détails du produit',
  'prd.detailsHelp': 'Description, référence, prix HT, taux de TVA, type et stock du produit.',
  'prd.editHelp': 'Modifiez le nom, le prix, la TVA, le type et le stock du produit.',
  'prd.delete': 'Supprimer le produit',
  'prd.deleteHelp': 'Déplacez le produit vers les éléments supprimés. Vous pourrez le restaurer plus tard.',
  'prd.itemNo': 'Réf.',
  'prd.colStockItem': 'Article',
  'prd.stockReasonDefault': 'Comptage physique',
  'prd.stock': 'Stock',
  'prd.deleted': 'Supprimé',
  'prd.pickOwnColour': 'Choisir votre propre couleur',
  'prd.namePh': 'Ex. Heure de conseil',
  'prd.priceExVat': 'Prix HT',
  'prd.price': 'Prix',
  'prd.priceIncVat': 'Prix TTC',
  'prd.subscriptionPeriod': 'Période d\'abonnement',
  'prd.multiDayDiscount': 'Remise multi-jours',
  'prd.multiDayHelp': 'S\'applique uniquement à ce produit de location.',
  'prd.day2ChargedAt': 'Le jour 2 est facturé à',
  'prd.day3Onwards': 'À partir du jour 3',
  'prd.itemNumber': 'Référence',
  'prd.accountFallbackName': 'Compte',
  'prd.acct3000': 'Ventes et prélèvements soumis à la TVA',
  'prd.acct3020': 'Chiffre d\'affaires services, taux de TVA élevé',
  'prd.acct3030': 'Chiffre d\'affaires marchandises, taux de TVA intermédiaire',
  'prd.acct3050': 'Chiffre d\'affaires marchandises, taux de TVA réduit',
  'prd.acct3100': 'Ventes et prélèvements à 0 pour cent de TVA',
  'prd.acct3200': 'Ventes et prélèvements hors champ de la loi sur la TVA',
  'prd.acct3900': 'Autres produits d\'exploitation',
  'prd.colProductName': 'Nom du produit',
  'prd.colDescription': 'Description',
  'prd.colVat': 'TVA',
  'prd.colType': 'Type',
  'prd.colRentalDiscount': 'Remise de location',
  'prd.colSalesAccount': 'Compte de ventes',
  'prd.colEquivalentAccount': 'Correspond au compte standard',
  'prd.excelImportUnavailable': 'L\'import Excel n\'est pas encore disponible.',
  'prd.excelExportUnavailable': 'L\'export Excel n\'est pas encore disponible.',
  'prd.colStatus': 'Statut',
  'prd.exportSheetName': 'Produits',
  'prd.typeHeading': 'Titre',
  'prd.typeTextLine': 'Ligne de texte',
  'prd.textLinesTitle': 'Lignes de texte',
  'prd.newTextLine': 'Nouvelle ligne de texte',
  'prd.updateTextLine': 'Mettre à jour la ligne de texte',
  'prd.saveTextLine': 'Enregistrer la ligne de texte',
  'prd.textLineNamePh': 'Ex. Texte de montage standard',
  'prd.textLineTextPh': 'Saisissez le texte à utiliser sur les lignes de document',
  'prd.styleFor': 'Style pour {target}',
  'prd.styleTargetText': 'Texte',
  'prd.styleTargetName': 'Nom',
  'prd.styleBold': 'Gras',
  'prd.styleItalic': 'Italique',
  'prd.styleDivider': 'Ligne de séparation',
  'prd.styleNoDivider': 'Sans ligne de séparation',
  'prd.styleSummary': 'Nom : {name} · Texte : {text} · {divider}',
  'prd.toastProductUpdated': 'Produit mis à jour',
  'prd.toastProductSaved': 'Produit enregistré',
  'prd.toastProductSaveError': 'Impossible d\'enregistrer le produit.',
  'prd.toastProductDeleted': 'Produit supprimé',
  'prd.toastProductDeleteError': 'Impossible de supprimer le produit.',
  'prd.toastTextLineUpdated': 'Ligne de texte mise à jour',
  'prd.toastTextLineSaved': 'Ligne de texte enregistrée',
  'prd.toastTextLineSaveError': 'Impossible d\'enregistrer la ligne de texte.',
  'prd.toastTextLineDeleted': 'Ligne de texte supprimée',
  'prd.toastTextLineDeleteError': 'Impossible de supprimer la ligne de texte.',
  'prd.toastImportNoneFound': 'Aucun produit trouvé dans le fichier.',
  'prd.toastImportSuccess': '{count} produits importés',
  'prd.toastImportError': 'Impossible d\'importer les produits.',
  'prd.toastExportNone': 'Aucun produit à exporter',
  'prd.toastExportDone': 'Liste des produits téléchargée',
  'prd.toastExportError': 'Impossible d\'exporter la liste des produits.',
  'prd.textLineFilterHelp': 'Filtrez les lignes de texte et titres enregistrés.',
  'prd.filterOther': 'Autre',
  'prd.showDeleted': 'Afficher les supprimés',
  'prd.typeGoods': 'Marchandise',
  'prd.typeService': 'Service',
  'prd.typeRental': 'Location',
  'prd.typeSubscription': 'Abonnement',
  'prd.stockOnly': 'En stock uniquement',
  'prd.textLineSubtitle': 'Textes et titres enregistrés pour les documents de vente',
  'prd.titleHelp': 'Vos produits — les marchandises et services que vous vendez, avec prix, TVA et stock. Touchez un produit pour voir les détails.',
  'prd.uploadHelp': 'Importer des produits depuis un fichier.',
  'prd.downloadHelp': 'Téléchargez la liste des produits au format CSV ou Excel.',
  'prd.addHelp': 'Ajoutez une nouvelle marchandise, un service, un abonnement ou un produit de location.',
  'prd.textLineSearchPh': 'Rechercher par nom, texte ou type',
  'prd.textLineSearchHelp': 'Rechercher dans les lignes de texte et titres enregistrés.',
  'prd.emptyText': 'Ajoutez les marchandises et services que vous vendez, et la facturation sera ultra-rapide.',
  'prd.textLineEmptyTitle': 'Aucune ligne de texte pour le moment',
  'prd.textLineEmptyText': 'Enregistrez des textes récurrents, des titres et des textes produit sans prix.',
  'prd.colBalance': 'Stock',
  'prd.colCostPerUnit': 'Coût unitaire',
  'prd.colTotalValue': 'Valeur totale',
  'prd.colStockAvailable': 'Stock/disponible',
  'prd.noneShort': 'Aucun',
  'prd.subscriptionLabel': 'Abonnement · {period}',
  'prd.month1Short': '1 mois',
  'prd.months12Short': '12 mois',
  'prd.copyToTextLine': 'Copier vers une ligne de texte',
  'prd.colProduct': 'Produit',
  'prd.colPrice': 'Prix',
  'prd.colName': 'Nom',
  'prd.colStyle': 'Style',
  'prd.errNrTaken': 'La référence « {nr} » est déjà utilisée.',
  'prd.errAccountCodeFormat': 'Utilisez un compte de produits qui commence par 3 et comporte 4 ou 5 chiffres.',
  'prd.errAccountNameRequired': 'Donnez un nom au compte.',
  'prd.errAccountEquivalentRequired': 'Choisissez le compte standard auquel celui-ci doit correspondre.',
  'prd.errAccountExists': 'Le compte {code} existe déjà.',
  'prd.errCostPriceInvalid': 'Le prix de revient doit être un montant valide d\'au moins 0.',
  'prd.errTrackingDateRequired': 'Choisissez la date de début de la gestion automatique des stocks.',
  'prd.errStockNegative': 'Le stock initial ne peut pas être négatif.',
  'prd.errCostPriceRequired': 'Saisissez un prix de revient pour le stock initial.',
  'prd.errCostPriceNegative': 'Le prix de revient ne peut pas être négatif.',
  'prd.noName': 'Sans nom',
  'prd.updateProduct': 'Mettre à jour le produit',
  'prd.saveProduct': 'Enregistrer le produit',
  'prd.rentalQtyLabel': 'Quantité disponible à la location',
  'prd.autoInventoryTitle': 'Stock et coût des marchandises automatiques',
  'prd.autoInventoryHelp': 'Les achats augmentent le stock. Les ventes comptabilisées réduisent le stock et enregistrent le coût des marchandises calculé selon le coût moyen pondéré.',
  'prd.calculatedStock': 'Stock calculé',
  'prd.openingStock': 'Stock initial',
  'prd.avgCostPrice': 'Prix de revient moyen',
  'prd.costPerUnit': 'Prix de revient unitaire',
  'prd.inventoryValueLine': 'Valeur du stock : {value}',
  'prd.month1': '1 mois',
  'prd.months12': '12 mois',
  'prd.advancedTitle': 'Données produit avancées',
  'prd.advancedHelp': 'SKU, EAN/GTIN, groupe de produits et données d\'import.',
  'prd.noGroup': 'Aucun groupe',
  'prd.removeGroup': 'Retirer le groupe de produits',
  'prd.newGroupPh': 'Nouveau groupe de produits',
  'prd.brand': 'Marque',
  'prd.variantName': 'Nom de la variante',
  'prd.supplierItemNumber': 'Réf. article fournisseur',
  'prd.internalReference': 'Référence interne',
  'prd.tags': 'Étiquettes',
  'prd.tagsPh': 'Ex. boutique en ligne, pièce détachée, hiver',
  'prd.saveAsTextLineTitle': 'Enregistrer aussi comme ligne de texte',
  'prd.saveAsTextLineHelp': 'Crée une copie sans prix pour les lignes de document.',
  'prd.autoAccountLine': 'Automatique : {account}',
  'prd.accountTypeLabel': 'Type de compte',
  'prd.selectAccount': 'Choisir un compte',
  'prd.customAccountOption': 'Personnalisé',
  'prd.accountInLedger': 'Compte comptable',
  'prd.accountNamePh': 'Refacturation',
  'prd.equivalentForYearEnd': 'Équivalent pour comptes annuels/impôt',
  'prd.selectStandardAccount': 'Choisir un compte standard',
  'sub.tabsHelp': 'Passez des abonnements à facturation récurrente aux listes de clients pour une facturation groupée ou un e-mail.',
  'sub.start': 'Début',
  'sub.end': 'Fin',
  'sub.endHelp': 'Laissez vide pour continuer jusqu\'à ce que l\'abonnement soit suspendu ou supprimé.',
  'sub.internalComment': 'Commentaire interne',
  'sub.saveCustomers': 'Enregistrer les clients',
  'sub.searchCustomers': 'Rechercher des clients',
  'sub.searchCustomersPh': 'Rechercher par nom, e-mail ou n° d\'organisation...',
  'sub.selectVisible': 'Sélectionner les éléments visibles',
  'sub.deselectVisible': 'Désélectionner les éléments visibles',
  'sub.noCustomers': 'Aucun client pour l\'instant',
  'sub.howToInvoice': 'Comment souhaitez-vous facturer ?',
  'sub.manualFlowNote': 'Le choix ci-dessous lance un processus de facturation manuel pour l\'abonnement.',
  'sub.sendInvoice': 'Envoyer la facture',
  'sub.openDraftFilled': 'Ouvrir un brouillon de facture avec l\'abonnement déjà renseigné.',
  'sub.openBlankDraft': 'Ouvrir un brouillon de facture vierge avec le groupe de clients sélectionné.',
  'sub.subject': 'Objet',
  'sub.message': 'Message',
  'sub.removeAllAttachments': 'Retirer toutes les pièces jointes',
  'sub.addCustomers': 'Ajouter des clients',
  'sub.noInvoiceSent': 'Aucune facture envoyée',
  'sub.noEmailSent': 'Aucun e-mail envoyé',
  'sub.unknownCustomer': 'Client inconnu',
  'sub.customersCount': '{count} clients',
  'sub.cpiAnnualSuffix': ' · IPC {rate} % par an',
  'sub.actionMenuLabel': 'Action',
  'sub.nameRequiredSubscription': 'Donnez un nom à l\'abonnement',
  'sub.nameRequiredList': 'Donnez un nom à la liste',
  'sub.nameRequiredListError': 'Donnez un nom à la liste.',
  'sub.nameRequiredAgreementError': 'Donnez un nom au contrat.',
  'sub.editSubTitle': 'Modifier l\'abonnement',
  'sub.editListTitle': 'Modifier la liste',
  'sub.newSubTitle': 'Nouvel abonnement',
  'sub.newListTitle': 'Nouvelle liste',
  'sub.saveChanges': 'Enregistrer les modifications',
  'sub.saveSubscription': 'Enregistrer l\'abonnement',
  'sub.saveList': 'Enregistrer la liste',
  'sub.namePlaceholderSub': 'Ex. Adhésion Or',
  'sub.namePlaceholderList': 'Ex. Newsletter',
  'sub.nextInvoiceDateLabel': 'Prochaine date de facturation',
  'sub.cpiAdjustmentLabel': 'Indexation IPC',
  'sub.cpiAdjustmentHelp': 'Indexation annuelle du prix de l\'abonnement sur l\'indice des prix à la consommation.',
  'sub.customerSavedToast': 'Client « {name} » enregistré',
  'sub.saveCustomerError': 'Impossible d\'enregistrer le client.',
  'sub.addCustomersTitle': 'Ajouter des clients · {name}',
  'sub.selectedCount': '{count} sélectionnés',
  'sub.addAsNewCustomer': 'Ajouter « {name} » comme nouveau client',
  'sub.noContactInfo': 'Aucune coordonnée',
  'sub.addCustomersEmptyText': 'Ajoutez d\'abord des clients dans le registre des clients, ou saisissez un nom pour créer un nouveau client.',
  'sub.sendInvoiceTitle': 'Envoyer la facture · {name}',
  'sub.attachmentTooLarge': 'Les pièces jointes ne peuvent pas dépasser {max}.',
  'sub.fillSubject': 'Renseignez l\'objet.',
  'sub.writeMessage': 'Rédigez un message.',
  'sub.sendEmailTitle': 'Envoyer un e-mail · {name}',
  'sub.sending': 'Envoi...',
  'sub.sendEmailButton': 'Envoyer l\'e-mail',
  'sub.readyCount': '{count} prêts',
  'sub.attachmentsAddedCount': '{count} pièces jointes ajoutées',
  'sub.addAttachment': 'Ajouter une pièce jointe',
  'sub.emailSendNote': 'Les e-mails sont envoyés via le serveur. Vous pouvez déposer des fichiers n\'importe où dans la fenêtre ou les coller avec Ctrl+V. Les destinataires sans adresse e-mail sont journalisés comme non envoyés.',
  'sub.typeSubscription': 'Abonnement',
  'sub.typeList': 'Liste',
  'sub.actionClose': 'Fermer',
  'sub.actionOpen': 'Ouvrir',
  'sub.edit': 'Modifier',
  'sub.emailLabel': 'E-mail',
  'sub.resume': 'Reprendre',
  'sub.pause': 'Suspendre',
  'sub.delete': 'Supprimer',
  'sub.tabCustomers': 'Clients ({count})',
  'sub.tabInvoices': 'Factures ({count})',
  'sub.tabEmails': 'E-mails ({count})',
  'sub.addCustomersToInvoiceText': 'Ajoutez des clients pour les facturer.',
  'sub.removeMember': 'Retirer',
});
